import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.FILE.DOWNLOAD, fileData => {
  if (!fileData || !fileData.url) return

  const parts = fileData.url.split('/')
  const fileName = parts[parts.length - 1]
  const fileExtension = fileName
    .split('.')
    .pop()
    .toLowerCase()

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'file_download',
    file_name: fileData.name || fileName,
    link_text: fileData.text || fileName,
    link_url: fileData.url,
    file_extension: fileExtension,
  })
})
